var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 147,
    viewBox: "0 0 500 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 147,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3867)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7608 93.9291C44.7608 93.9291 43.4933 93.9291 42.5749 93.7088C42.0056 93.5721 41.3908 93.3747 40.7305 93.0861L57.5046 102.777C60.0245 104.327 64.1991 104.41 66.7873 102.975L68.0473 102.246C68.6317 101.813 69.1175 101.38 69.5122 100.954C70.1573 100.271 70.7949 99.1696 70.7949 99.1696L73.8234 93.9215H44.7608V93.9291Z",
    fill: "url(#paint0_linear_0_3867)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7945 99.1772C70.7945 99.1772 70.1569 100.279 69.5118 100.962C69.1095 101.387 68.6313 101.82 68.0469 102.253L84.821 92.562C87.4168 91.1494 89.5876 87.5798 89.6332 84.6177V83.1595C89.5497 82.4456 89.4206 81.8076 89.2536 81.2456C88.988 80.3418 88.3504 79.2405 88.3504 79.2405L85.322 73.9924L70.7945 99.1696V99.1772Z",
    fill: "url(#paint1_linear_0_3867)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1712 55.6354L83.9113 54.9063C83.2509 54.6177 82.6361 54.4202 82.0593 54.2759C81.1485 54.0557 79.8733 54.0557 79.8733 54.0557H73.8164L88.3515 79.2329C88.3515 79.2329 88.989 80.3341 89.2547 81.2379C89.4217 81.8 89.5583 82.4379 89.6342 83.1519V63.7696C89.7101 60.8152 87.6987 57.1468 85.1636 55.6278L85.1712 55.6354Z",
    fill: "url(#paint2_linear_0_3867)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2904 68.7519C36.2904 68.7519 35.6529 67.6506 35.3872 66.7468C35.2202 66.1848 35.0836 65.5544 35.0001 64.8329V84.2152C34.9242 87.1696 36.9356 90.8379 39.4707 92.3569L40.7307 93.086C41.391 93.3747 42.0134 93.5797 42.5751 93.7088C43.4935 93.9291 44.761 93.9291 44.761 93.9291H50.8179L36.2904 68.7519Z",
    fill: "url(#paint3_linear_0_3867)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8733 54.0633C79.8733 54.0633 81.1409 54.0633 82.0593 54.2835C82.6285 54.4202 83.2433 54.6253 83.9112 54.9139L67.1295 45.2228C64.6096 43.6734 60.435 43.5823 57.8468 45.0177L56.5868 45.7468C56.01 46.1797 55.5242 46.6126 55.122 47.0379C54.4768 47.7215 53.8392 48.8228 53.8392 48.8228L50.8184 54.0709H79.8733V54.0633Z",
    fill: "url(#paint4_linear_0_3867)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8197 55.438C37.2239 56.8506 35.0531 60.4202 35 63.3823V64.8405C35.0835 65.562 35.2125 66.1924 35.3871 66.7544C35.6527 67.6582 36.2903 68.7595 36.2903 68.7595L39.3112 74.0076L53.8387 48.8228C53.8387 48.8228 54.4762 47.7215 55.1214 47.038C55.5237 46.6126 56.0094 46.1797 56.5863 45.7468L39.8197 55.438Z",
    fill: "url(#paint5_linear_0_3867)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3867",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 43,
    width: 56,
    height: 61
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1707 55.6352L67.1291 45.2225C64.6091 43.6731 60.4346 43.582 57.8464 45.0175L39.8198 55.4377C37.224 56.8504 35.0533 60.42 35.0001 63.382V84.2149C34.9242 87.1693 36.9356 90.8377 39.4707 92.3567L57.5048 102.777C60.0247 104.326 64.1993 104.41 66.7875 102.974L84.8216 92.5542C87.4174 91.1415 89.5882 87.5719 89.6337 84.6099V63.7769C89.7096 60.8225 87.6983 57.1542 85.1632 55.6352H85.1707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3118 74C39.3118 74 35.9266 60.519 44.5186 52.6278L48.7994 50.1443C48.7994 50.1443 37.3156 57.2911 39.3118 74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8175 93.9291C50.8175 93.9291 37.4513 90.1241 34.9238 78.7317V73.7874C34.9238 73.7874 35.3565 87.3063 50.8175 93.9291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8147 93.9292C73.8147 93.9292 63.8413 103.605 52.7142 100.104L48.4258 97.6355C48.4258 97.6355 60.3498 104.015 73.8071 93.9292H73.8147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3138 74C85.3138 74 88.699 87.481 80.107 95.3722L75.8262 97.8557C75.8262 97.8557 87.31 90.7165 85.3138 74.0076V74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8164 54.0709C73.8164 54.0709 87.1826 57.876 89.7101 69.2684V74.2127C89.7101 74.2127 89.2775 60.6937 73.8164 54.0709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8184 54.0709C50.8184 54.0709 60.7918 44.395 71.9113 47.8962L76.1997 50.3646C76.1997 50.3646 64.2756 43.9772 50.8184 54.0709Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.434 80.7139V62.1443H240.441V66.9367H250.984V80.7139H256.434Z",
    fill: "#636466"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.428 85.0582C187.244 85.0582 183.039 89.2658 183.039 94.4532C183.039 99.6405 187.244 103.856 192.428 103.856C197.612 103.856 201.817 99.6481 201.817 94.4532C201.817 89.2582 197.612 85.0582 192.428 85.0582ZM192.428 98.7367C190.068 98.7367 188.162 96.8228 188.162 94.4608C188.162 92.0987 190.075 90.1924 192.428 90.1924C194.781 90.1924 196.701 92.1063 196.701 94.4608C196.701 96.8152 194.789 98.7367 192.428 98.7367Z",
    fill: "#636466"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.854 61.5443H196.32V82.8481H201.854V74.1139H206.909V69.2456H201.854V61.5443Z",
    fill: "#636466"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.324 77.7975H220.829V85.5823H208.715V90.4506H238.438V85.5823H226.324V77.7975Z",
    fill: "#636466"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M215.166 79.5215L223.576 70.5443L231.986 79.5215L235.986 75.8L227.698 67.1645H234.87V62.1443H212.29V67.1645H219.455L211.174 75.8L215.166 79.5215Z",
    fill: "#636466"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M416.23 83.7139H421.406V61.5443H416.23V68.6987H411.736V73.5595H416.23V83.7139Z",
    fill: "#636466"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.534 61.5443H383.152V83.7063H388.534V61.5443Z",
    fill: "#636466"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M429.944 61.5443H424.562V83.7063H429.944V61.5443Z",
    fill: "#636466"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 69.2608H125.505V61.5443H120.328V92.6228H125.505V74.2051H129.482V92.6228H134.871V61.5443H129.482V69.2608Z",
    fill: "#636466"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.682 67.0886H115.509V62.1443H101.148V84.2228H116.131V79.2861H106.682V67.0886Z",
    fill: "#636466"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M191.683 77.4253L184.716 66.8987H190.53V61.9544H184.26V58.438H178.378V61.9544H172.109V66.8987H177.923C175.22 70.9772 170.947 77.4253 170.947 77.4253L175.425 80.4557L181.315 71.1823L187.198 80.4557L191.676 77.4253H191.683Z",
    fill: "#636466"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M345.602 67.157H339.826V71.7975H345.602V75.5418H339.826V80.1899H345.602V84.7544H351.135V61.5443H345.602V67.157Z",
    fill: "#636466"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M262.416 85.0582C257.232 85.0582 253.027 89.2658 253.027 94.4532C253.027 99.6405 257.232 103.856 262.416 103.856C267.6 103.856 271.805 99.6481 271.805 94.4532C271.805 89.2582 267.6 85.0582 262.416 85.0582ZM262.416 98.7367C260.056 98.7367 258.143 96.8228 258.143 94.4608C258.143 92.0987 260.056 90.1924 262.416 90.1924C264.777 90.1924 266.69 92.1063 266.69 94.4608C266.69 96.8152 264.777 98.7367 262.416 98.7367Z",
    fill: "#636466"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M375.866 77.1975L365.505 61.5443L355.145 77.1975L359.623 80.2203L365.505 70.9544L371.395 80.2203L375.866 77.1975Z",
    fill: "#636466"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M376.084 87.2303H370.627V101.98H388.881V97.119H376.084V87.2303Z",
    fill: "#636466"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M459.645 61.5443V71.8203H454.34V76.6886H459.645V92.6228H465.171V61.5443H459.645Z",
    fill: "#636466"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M417.496 87.2303H412.039V101.98H430.293V97.119H417.496V87.2303Z",
    fill: "#636466"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M441.778 76.5975H451.698V71.881H441.778V67.0126H452.108V62.1443H436.328V86.6987H452.518V81.762H441.778V76.5975Z",
    fill: "#636466"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M402.498 61.5443L392.426 77.1443L396.904 80.1747L402.498 70.9544L408.084 80.1747L412.562 77.1443L402.498 61.5443Z",
    fill: "#636466"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M294.711 67.0886V62.1443H277.937V67.0886H283.015L276.26 77.5544L280.73 80.5848L286.324 71.3645L291.918 80.5848L296.396 77.5544L289.634 67.0886H294.711Z",
    fill: "#636466"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M299.933 68.6987H294.863V73.5595H299.933V92.6228H305.11V61.5443H299.933V68.6987Z",
    fill: "#636466"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M266.309 65.243H260.533V69.8911H266.309V73.6279H260.533V78.276H266.309V82.8481H271.842V61.5443H266.309V65.243Z",
    fill: "#636466"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M313.657 61.5443H308.268V92.6228H313.657V61.5443Z",
    fill: "#636466"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M332.814 93.5494H345.179V102.656H350.712V88.681H332.814V93.5494Z",
    fill: "#636466"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M337.293 76.0203C337.293 71.4101 333.559 67.681 328.959 67.681C324.359 67.681 320.625 71.4101 320.625 76.0203C320.625 80.6304 324.359 84.3595 328.959 84.3595C333.559 84.3595 337.293 80.6304 337.293 76.0203ZM328.959 79.2861C327.16 79.2861 325.695 77.8279 325.695 76.0203C325.695 74.2127 327.16 72.762 328.959 72.762C330.758 72.762 332.215 74.2203 332.215 76.0203C332.215 77.8203 330.758 79.2861 328.959 79.2861Z",
    fill: "#636466"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M338.143 61.962H331.714V58.4456H325.832V61.962H319.35V66.7544H338.143V61.962Z",
    fill: "#636466"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 79.0962L157.732 76.5595L151.356 66.7848H156.7V62.1443H140.017V66.7848H145.36L138.992 76.5595L142.878 79.0962L148.358 70.681L153.846 79.0962Z",
    fill: "#636466"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M163.538 81.8987H168.176V62.1443H163.538V68.1671H157.785V72.8152H163.538V81.8987Z",
    fill: "#636466"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 94.0582V85.1797H152.062V94.0582V98.2961V98.6987H168.746V94.0582H156.7Z",
    fill: "#636466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3867",
    x1: 54.5445,
    y1: 97.5899,
    x2: 70.6707,
    y2: 88.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6FB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3867",
    x1: 79.0829,
    y1: 73.7266,
    x2: 78.8473,
    y2: 92.9342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_3867",
    x1: 70.583,
    y1: 59.4025,
    x2: 86.9451,
    y2: 69.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6FB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_3867",
    x1: 53.945,
    y1: 88.8025,
    x2: 37.8257,
    y2: 78.9686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_3867",
    x1: 53.6115,
    y1: 59.4101,
    x2: 70.0945,
    y2: 50.4113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_3867",
    x1: 46.036,
    y1: 74.1975,
    x2: 45.7928,
    y2: 55.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6FB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430.169,
    height: 60,
    fill: "white",
    transform: "translate(35 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/대전창조경제혁신센터.86e3dd15df8c4ed6c128499c4ac77e9a.svg";
export { ForwardRef as ReactComponent };